import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

import QMenuStore from './modules/QMenuStore'
import QVocabularyStore from './modules/QVocabularyStore'

import Site from '@/api/Site'
import QUnit from '@/api/QUnit'
import User from '@/api/User'
import Standard from '@/api/Standard'
import Process from '@/api/Process'
import QMenuItem from '@/api/QMenuItem'
import QVocabularyItem from '@/api/QVocabularyItem'
import QDirectory from '@/api/QDirectory'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    allSites: [], // to store all sites (for menu)
    allStandards: [],
    allProcesses: [],
    filteredProcesses: [],
    current_business_process: '',
    current_parent_process: '',
    current_unit: {},
    currentUser: {},
    context_title: 'Processes',
    filtersFormData: [],
    isLoading: true,
    menus: [],
    message: '',
    currentStandardID: null,
    processID: '',
    searchText: '',
    rootSite: '',
    sitePath: '',
    sites: [], // all sites on current tree node
    transition_candidates: [],
    unitColumns: [],
    units: [],
    unitsCount: 0,
    unitsItemsPerPage: 0,
    user: { id: null },
    users: [],
    current_view: 'ExplorerTable',
    notifications: [],
    notifications_count: 0,
    current_business_process_name: '',
    current_page_number: 1,
    table_selected: [],
    form_process: '',
    filterDates: [],
    calendar_units: [],
    explorer_sort_by: 'current_workflow_limit',
    explorer_sort_desc: false,
    // Error handling
    showAlert: false,
    alertMessage: '',
    qdirectory: {},       // {dir_id: {directory props}}
    qdirectory_list: [],  // [{dir props}]
    activeDirectory: {},  // Active directory
    filterDirectory: [],  // Selected directories id
    showSpinner:false,
  }
}

function sleep(ms) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

// initial state
const state = getDefaultState()

const getters = {
  isUser: state => state.user.id !== null,
  isManager: state => state.user.isManager || false,
  isAdmin: state => state.user.isAdmin || false,
}

const actions = {
  GET_ALL_SITES({ commit }, root_site) {
    commit('SET_LOADING', true)
    return Site.getAll(root_site)
      .then(data => {
        commit('SET_ALL_SITES', data['results'])
      })
      .catch(error => commit('SET_MESSAGE', error))
  },
  GET_SITES({ commit }, site) {
    commit('SET_LOADING', true)
    return Site.getAll(site)
      .then(data => {
        commit('SET_SITES', data['results'])
      })
      .catch(error => commit('SET_MESSAGE', error))
  },
  LOAD_STANDARDS({ commit }, site) {
    commit('SET_LOADING', true)
    return Standard.getTree(site)
      .then(data => {
        commit('SET_STANDARDS', data)
      })
      .catch(error => commit('SET_MESSAGE', error))
  },
  LOAD_PROCESSES({ commit }, site) {
    commit('SET_LOADING', true)
    return Process.getTree(site)
      .then(data => {
        commit('SET_PROCESSES', data)
      })
      .catch(error => commit('SET_MESSAGE', error))
  },
  LOAD_MENU_ITEMS({ commit }, site) {
    commit('SET_LOADING', true)
    return QMenuItem.getQMenuItemsFull(site)
      .then(data => {
        commit('SET_MENU_ITEMS', data)
      })
      .catch(error => commit('SET_MESSAGE', error))
  },

  LOAD_VOCABULARY_ITEMS({ commit }, site) {
    commit('SET_LOADING', true)
    return QVocabularyItem.getQVocabularyItems(site)
      .then(data => {
        commit('SET_VOCABULARY_ITEMS', data)
      })
      .catch(error => commit('SET_MESSAGE', error))
  },
  EXPLORE_UNITS(
    { commit },
    {
      site,
      bp_reference,
      process_id,
      search_text,
      filters_form,
      units_page,
      units_sort_by = 'current_workflow_limit',
      units_sort_desc = false,
      pk = '',
      filter_dates = [],
      filter_directory = [],
    },
  ) {
    commit('RESET_UNITS_DATA')
    if (state.isLoading) {
      console.log('waiting')
      sleep(500)
    }
    commit('SET_LOADING', true)
    var offset = (units_page - 1) * state.unitsItemsPerPage
    console.log("EXPLORE_UNITS", units_page, state.unitsItemsPerPage)
    return QUnit.getExplorer(
      site,
      bp_reference,
      process_id,
      search_text,
      filters_form,
      offset,
      units_sort_by,
      units_sort_desc,
      pk,
      filter_dates,
      filter_directory,
    )
      .then(data => {
        commit('SET_UNITS_DATA', data), commit('SET_LOADING', false)
        commit(
          'SET_BUSINESS_PROCESS_NAME',
          data['current_business_process_name']
        )
        commit(
          'SET_CONTEXT_TITLE',
          data['current_business_process_name']
        )        
        commit('SET_CURRENT_PAGE_NUMBER', data['current_page_number'])
        commit('SET_EXPLORER_SORT_BY', units_sort_by)
        commit('SET_EXPLORER_SORT_DESC', units_sort_desc)
        console.log("EXPLORE_UNITS page_number", data['current_page_number'])
        if (pk){
          for (var i=0; i<data['results'].length;i++){
            var item = data['results'][i]
            if (item.uid == pk){
                commit('SET_TABLE_SELECTED', [item])
            }
          }
        }
        commit('SET_LOADING', false)
      })
      .catch(error => {
        commit('SET_MESSAGE', error)
      })
  },
  EXPLORE_UNITS_CALENDAR(
    { commit },
    {
      site,
      bp_reference,
      process_id,
      search_text,
      filters_form,
      start,
      end
    }) {
    // commit('SET_LOADING', true)
    commit('RESET_CALENDAR_UNITS_DATA')
    return QUnit.getExplorerCalendar(
      site,
      bp_reference,
      process_id,
      search_text,
      filters_form,
      start,
      end
    ).then(data => {
      commit('SET_CALENDAR_UNITS_DATA', data)
      // commit('SET_LOADING', false)
      // commit(
      //   'SET_BUSINESS_PROCESS_NAME',
      //   data['current_business_process_name']
      // )
      // commit(
      //   'SET_CONTEXT_TITLE',
      //   data['current_business_process_name']
      // )
    })
      .catch(
      error => {
        commit('SET_MESSAGE', error)
      },
    )
  },
  EXPLORE_UNITS_TODOLIST(
      { commit },
      {
        site,
        user_id,
        process_id,
        search_text,
        filters_form,
        units_page,
        units_sort_by = 'current_workflow_limit',
        units_sort_desc = false,
        pk = '',
        filter_dates = [],
      },
  ) {
    if (state.isLoading) {
      console.log('waiting')
      sleep(500)
    }
    commit('SET_LOADING', true)
    var offset = (units_page - 1) * 10
    return QUnit.getTodoList(
        site,
        user_id,
        process_id,
        search_text,
        filters_form,
        offset,
        units_sort_by,
        units_sort_desc,
        pk,
        filter_dates,
    )
      .then(data => {
        commit('SET_UNITS_DATA', data), commit('SET_LOADING', false)
        commit('SET_CURRENT_PAGE_NUMBER', data['current_page_number'])
        commit('SET_LOADING', false)
      })
      .catch(error => {
        console.log('error', error)
        commit('SET_MESSAGE', error)
      })    
  },
    
  UPDATE_UNITS_TABLE({ commit }, { new_units }) {
    if (state.isLoading) {
      console.log('waiting')
      sleep(500)
    }
    commit('SET_UNITS', new_units)
    commit('SET_LOADING', false)        
  },  
  OPEN_UNIT({ commit }, { site, pk }) {
    return QUnit.getTransitionCandidates(site, pk)
      .then(data => {
        commit('SET_TRANSITION_CANDIDATES', data),
          QUnit.getQUnit(site, pk)
            .then(data => {
              commit('SET_CURRENT_UNIT', data)
            })
            .catch(error => commit('SET_MESSAGE', error))
      })
      .catch(error => commit('SET_MESSAGE', error))
  },

  GET_USERS({ commit }, site) {
    return User.getAll(site)
      .then(data => {
        commit('SET_USERS', data['results'])
      })
      .catch(error => console.log('ERROR GETTING USERS ' + error))
  },
  RESET_STATE({ commit }) {
    commit('RESET_STATE')
  },
  DEFINE_ROOT_SITE({ commit }, site) {
    commit('SET_ROOT_SITE', site)
  },
  REFRESH_STATE({ commit }, context) {
    if (
      context.$auth.isAuthenticated() &&
      context.$session.exists('user') &&
      !context.isUser
    ) {
      var token = localStorage['vue-authenticate.vueauth_token']
      if (token) {
        context.$http
          .get(context.$base + '/api/v1/token/' + token + '/')
          .then(response => {
            commit('SET_USER', context.$session.get('user'))
          })
          .catch(err => {
            // Token is not valid in the server. Logout JS Session
            commit('SET_USER', '')
            context.$session.remove('user')
            localStorage['vue-authenticate.vueauth_token'] = ''
            context.$auth.logout()
            context.$router.push('login')
          })
      }
    }
    if (context.$session.get('site') && context.$session.exists('user')) {
      commit('SET_CURRENT_SITE', context.$session.get('site'))
      commit('SET_ROOT_SITE', context.$session.get('root_site'))
      context.$store.dispatch(
        'GET_ALL_SITES',
        context.$session.get('root_site'),
      )

      context.$store.dispatch('GET_SITES', context.$session.get('site'))
      context.$store.dispatch('LOAD_STANDARDS', context.$session.get('site'))
      context.$store.dispatch('LOAD_PROCESSES', context.$session.get('site'))
      context.$store.dispatch('LOAD_MENU_ITEMS', context.$session.get('site'))
      context.$store.dispatch(
        'LOAD_VOCABULARY_ITEMS',
        context.$session.get('site'),
      )
      context.$store.dispatch(
        'LOAD_DIRECTORY_ITEMS',
        state.sitePath,
      )
      context.$store.dispatch(
        'LOAD_USER_NOTIFICATIONS',
        context,
      )
    }
  },
  LOAD_USER_NOTIFICATIONS({ commit }, context){
    if (context.$auth.isAuthenticated() && context.$session.exists('user')) {
      QUnit.getUserNotifications(
        context.$session.get('site'),
        'NOTIF_DEFAULT',
        context.$session.get('user').id
      )
      .then(data => {
        commit('SET_CURRENT_USER_NOTIFICATIONS', data)
      })
    }
  },

  LOAD_DIRECTORY_ITEMS({ commit }, sitePath) {
    commit('SET_LOADING', true)
    return QDirectory.list(sitePath)
      .then(data => { commit('SET_DIRECTORY_ITEMS', data.data), commit('SET_LOADING', false) })
      .catch(error => {
        commit('SET_MESSAGE', error)
        // commit('SET_LOADING', false)
      });
  },
};

const mutations = {
  RESET_STATE(state) {
    Object.assign(state, getDefaultState())
  },

  SET_CURRENT_SITE(state, sitePath) {
    state.sitePath = sitePath
    if (!state.rootSite) state.rootSite = sitePath
  },

  SET_ROOT_SITE(state, sitePath) {
    state.rootSite = sitePath
  },

  SET_ALL_SITES(state, sites) {
    state.allSites = sites
    state.isLoading = false
  },

  SET_SITES(state, sites) {
    state.sites = sites
    state.isLoading = false
  },

  SET_CURRENT_STANDARD(state, standardId) {
    state.currentStandardID = standardId
  },
  SET_CURRENT_PROCESS(state, process_id) {
    state.processID = process_id
  },
  SET_STANDARDS(state, standards) {
    state.allStandards = standards
    state.allStandards.unshift({ id: '', name: 'Todos' })
    state.isLoading = false
  },
  SET_PROCESSES(state, processes) {
    var _processes = processes
    if (state.currentStandardID) {
      _processes = processes.filter(p => p.standard === state.currentStandardID)
    } else {
      if (_processes.length > 0) {
        _processes.unshift({ id: '', name: 'Todos', parent: '' })
      }
    }
    state.allProcesses = processes
    state.filteredProcesses = _processes

    state.isLoading = false
  },

  SET_MENU_ITEMS(state, items) {
    state.menus = items
    state.isLoading = false
  },

  SET_VOCABULARY_ITEMS(state, items) {
    state.vocabularies = items
    state.isLoading = false
  },

  SET_DIRECTORY_ITEMS(state, items) {
    state.qdirectory = {}
    state.qdirectory_list = items;

    function process_items(items, path) {
      for (let item of items) {
        item.path = path.concat(item);
        state.qdirectory[item.id] = item;
        if (item.children)
          process_items(item.children, item.path);
      }
    }
    process_items(items, []);
  },

  SET_LOADING(state, value) {
    state.isLoading = value
  },

  SET_MESSAGE(state, value) {
    state.message = value
  },

  SET_CURRENT_UNIT(state, unit) {
    // var fields = {}
    // var fields_list = []
    // for (var i = 0; i < unit['workflow'].length; i++) {
    //   var transaction = unit['workflow'][i]
    //   for (var j = 0; j < transaction['fields'].length; j++) {
    //     var field_id = transaction['fields'][j]['id']
    //     fields[field_id] = transaction['fields'][j]
    //     if (!fields_list.includes(field_id)) fields_list.push(field_id)
    //   }
    // }

    // var aggregatted_fields = []
    // for (var i = 0; i < fields_list.length; i++) {
    //   aggregatted_fields.push(fields[fields_list[i]])
    // }
    // unit['fields'] = aggregatted_fields

    state.current_unit = unit
  },

  SET_BUSINESS_PROCESS(state, bp) {
    state.current_business_process = bp
  },

  SET_BUSINESS_PROCESS_NAME(state, bp_name) {
    state.current_business_process_name = bp_name
  },
  
  SET_CURRENT_PAGE_NUMBER(state, page_number) {
    state.current_page_number = page_number
  },
  
  SET_PARENT_PROCESS(state, bp) {
    state.current_parent_process = bp
  },

  SET_UNITS(state, units) {
    state.units = units
    if (units && !state.unitsItemsPerPage)
      state.unitsItemsPerPage = 10
  },

  SET_CALENDAR_UNITS_DATA(state, data) {
    state.calendar_units = data
  },

  SET_UNITS_DATA(state, data) {
    var columns = data['labels']
    var units = data['results']

    state.unitColumns = Object.entries(columns).map(label => ({
      key: label[0],
      ...label[1],        
    }))

    state.units = units
//     if (units && !state.unitsItemsPerPage || state.unitsItemsPerPage != units.length )
    state.unitsItemsPerPage = 10
    state.unitsCount = data['count']
  },

  RESET_UNITS_DATA(state) {
    state.units = []
    state.unitsCount = 0
  },

  RESET_CALENDAR_UNITS_DATA(state) {
    state.calendar_units = []
  },

  SET_UNIT_COLUMNS(state, columns) {
    // Table colums must be in format
    //  {
    //    key: prop_name_of_the_object,
    //    label: string,
    //    ...other props
    //  }
    state.unitColumns = Object.entries(columns).map(label => ({
      key: label[0],
      ...label[1],
    }))
  },

  SET_EXPLORER_SORT_BY(state, value) {
    state.explorer_sort_by = value
  },

  SET_EXPLORER_SORT_DESC(state, value) {
    state.explorer_sort_desc = value
  },

  SET_TRANSITION_CANDIDATES(state, transitions) {
    state.transition_candidates = transitions
  },

  // USERS
  SET_CURRENT_USER(state, user) {
    state.currentUser = user
    state.isLoading = false
  },
  SET_USER(state, user) {
    state.user = user
    state.isLoading = false
  },
  SET_USERS(state, users) {
    state.users = users
    state.isLoading = false
  },

  // ALERTS
  DISMISS_ALERT(state) {
    state.showAlert = false
    state.alertMessage = null
  },
  SHOW_ALERT(state, message) {
    state.showAlert = true
    state.alertMessage = message
  },

  // Search and filter data
  SET_SEARCH_TEXT(state, searchText) {
    state.searchText = searchText
  },
  SET_FILTER_FORM(state, filterFormData) {
    state.filterFormData = filterFormData
  },
  SET_FILTER_DATES(state, filterDates) {
    state.filterDates = filterDates
  },
  SET_FILTER_DIRECTORY(state, directory_ids) {
    state.filterDirectory = directory_ids;
  },
  SET_ACTIVE_DIRECTORY(state, directory) {
    state.activeDirectory = directory;
  },
  SET_CONTEXT_TITLE(state, context_title) {
    state.context_title = context_title
  },
  
  SET_CURRENT_VIEW(state, view_name){
    state.current_view = view_name      
  },
  
  SET_CURRENT_USER_NOTIFICATIONS(state, notifications) {
    state.notifications = notifications
    var unread = 0
    for (var i=0; i<notifications.length;i++){
        if (!notifications[i].is_closed){ 
            unread = unread + 1
        }
    }
    state.notifications_count = unread    
  },

  SET_TABLE_SELECTED(state, selected){
    state.table_selected = selected
  },

  // FORMS
  SET_FORM_PROCESS(state, process_id){
    state.form_process = process_id
  },

  SET_SHOW_SPINNER(state, value) {
    console.log('SET_SHOW_SPINNER', value)
    state.showSpinner = value
  }
}


export default new Vuex.Store({
  modules: { QMenu: QMenuStore, QVocabulary: QVocabularyStore },
  state,
  getters,
  actions,
  mutations,
})
